<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col
            :lg="7"
            :md="8"
            :sm="24"
            :xl="6"
            v-if=" !userInfo.thirdAccount && !hiddenQueryItems.includes('corpId')"
          >
            <a-form-item label="所属企业">
              <j-dict-select-tag
                @change="searchQuery"
                dictCode="`iwt-wf`.wf_consumer_corp,corp_name,id"
                placeholder="请选择所属企业"
                v-model="queryParam.corpId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="11" :md="12" :sm="24" :xl="10">
            <a-form-item label="充水量日期">
              <j-date
                @change="searchQuery"
                class="query-group-cust"
                placeholder="请选择开始日期"
                v-model="queryParam.rechargeDate_begin"
              ></j-date>
              <span class="query-group-split-cust"></span>
              <j-date
                @change="searchQuery"
                class="query-group-cust"
                placeholder="请选择结束日期"
                v-model="queryParam.rechargeDate_end"
              ></j-date>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary" v-if=" !userInfo.thirdAccount && false">新增</a-button>
      <a-button @click="handleExportXls('企业充水量记录')" icon="download" type="primary">导出</a-button>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0 && !userInfo.thirdAccount">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="fileListSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text || !text.length">无文件</span>
          <div v-else>
            <div :key="index" v-for="(file, index) in text">
              <a-dropdown>
                <a @click="e => e.preventDefault()" class="ant-dropdown-link">
                  {{ file.fileName }}
                  <a-icon type="down" />
                </a>
                <a-menu slot="overlay">
                  <a-menu-item @click="previewFile(file.filePath)">
                    <a-icon type="eye" />预览
                  </a-menu-item>
                  <a-menu-item @click="downloadFile(file.filePath)">
                    <a-icon type="download" />下载
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
          </div>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleDetail(record)">详情</a>
          <a-divider type="vertical" />
          <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>

    <wf-consumer-corp-recharge-modal @ok="modalFormOk" ref="modalForm"></wf-consumer-corp-recharge-modal>
  </a-card>
</template>

<script>
  import { getAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WfConsumerCorpRechargeModal from './modules/WfConsumerCorpRechargeModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'WfConsumerCorpRechargeList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      WfConsumerCorpRechargeModal
    },
    props: {
      //表单禁用
      filter: {
        type: Object,
        default: () => { },
      }
    },
    watch: {
      filter: {
        handler (newVal, oldVal) {
          if (oldVal && JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
            this.searchQuery();
          }
        },
        deep: true
      }
    },
    data () {
      return {
        description: '企业充水量记录管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '企业',
            align: "center",
            sorter: true,
            dataIndex: 'corpId_dictText'
          },
          {
            title: '充水量(吨)',
            align: "center",
            sorter: true,
            dataIndex: 'rechargeCount'
          },
          {
            title: '充水量日期',
            align: "center",
            sorter: true,
            dataIndex: 'rechargeDate',
            customRender: function (text) {
              return !text ? "" : (text.length > 10 ? text.substr(0, 10) : text)
            }
          },
          {
            title: '支付证明',
            align: "center",
            dataIndex: 'pictures',
            scopedSlots: { customRender: 'fileListSlot' }
          },
          {
            title: '余额',
            align: "center",
            dataIndex: 'remainingVolume'
          },
          {
            title: '创建人',
            align: "center",
            dataIndex: 'createBy_dictText'
          },
          {
            title: '更新人',
            align: "center",
            dataIndex: 'updateBy'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/wf/recharge/list",
          delete: "/wf/recharge/delete",
          deleteBatch: "/wf/recharge/deleteBatch",
          exportXlsUrl: "/wf/recharge/exportXls",
          importExcelUrl: "wf/recharge/importExcel",

        },
        localFilter: {},
        isorter: {
          order: 'desc',
          column: 'rechargeDate'
        },
        dictOptions: {},
        superFieldList: [],
        disableMixinCreated: true,
      }
    },
    created () {
      this.getSuperFieldList();

      //如果是企业管理员登录，赋值corpId, 值为userInfo.corpIds
      if (!!this.userInfo.thirdAccount) {
        this.localFilter = {
          corpId: this.userInfo.corpIds
        }
        this.columns = this.columns.filter(col => col.dataIndex !== 'action')
      }

      if (this.filter?.corpId || this.localFilter?.corpId) {
        this.columns = this.columns.filter(col => col.dataIndex !== 'corpId_dictText')
        //写入queryParam，查询和导出都增加过滤条件
        this.queryParam.corpId = this.queryParam.corpId = this.filter?.corpId || this.localFilter?.corpId;
      }

      // 在 localFilter 设置完成后调用 loadData
      this.$nextTick(() => {
        this.loadData(1);
      });
    },
    computed: {
      importExcelUrl () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      hiddenQueryItems () {
        return this.filter ? Object.keys(this.filter) : [];
      },
      userInfo () {
        return this.$store.getters.userInfo
      }
    },
    methods: {
      loadData (arg) {
        if (!this.url.list) {
          this.$message.error('请设置url.list属性!')
          return
        }
        // 加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1
        }
        var params = this.getQueryParams()// 查询条件
        this.loading = true;

        // 合并 localFilter 和 filter
        const mergedFilter = { ...this.localFilter, ...this.filter };
        Object.assign(params, mergedFilter);

        console.log('loadData params:', params); // 添加日志以检查参数
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records || res.result;
            this.dataSource.map(item => {
              item.pictures = item.pictures ? JSON.parse(item.pictures) : []
            } )
            if (res.result.total) {
              this.ipagination.total = res.result.total
            } else {
              this.ipagination.total = 0
            }
          }
        }).finally(() => {
          this.loading = false
        })
      },
      previewFile (fileUrl) {
        const buf = Buffer.from(fileUrl)
        let url = window._CONFIG['onlinePreviewDomainURL'] + '?url=' + encodeURIComponent(buf.toString('base64'))
        window.open(url, '_blank')
      },
      //   downloadFile (filePath) {
      //     // 实现下载逻辑
      //     const link = document.createElement('a');
      //     link.href = filePath;
      //     link.download = filePath.substring(filePath.lastIndexOf('/') + 1);
      //     link.click();
      //   },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'corpId', text: '企业', dictCode: '`iwt-wf`.wf_consumer_corp,corp_name,id' })
        fieldList.push({ type: 'BigDecimal', value: 'rechargeCount', text: '充水量(吨)', dictCode: '' })
        fieldList.push({ type: 'date', value: 'rechargeDate', text: '充水量日期' })
        fieldList.push({ type: 'string', value: 'pictures', text: '支付证明', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'remainingVolume', text: '余额', dictCode: '' })
        fieldList.push({ type: 'string', value: 'createBy', text: '创建人', dictCode: '' })
        fieldList.push({ type: 'string', value: 'updateBy', text: '更新人', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>